const mEditionProductSalesLetters = {
  mEditionProductSalesLetters: {
    alerts: {
      createProductoPaginaIdroopActivarEdicion: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.'
      },

      updateProductoPaginaIdroopDesactivar: {
        success: 'La carta de venta fue desactivada exitosamente.',
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.'
      },

      updateProductoPaginaIdroopPublicar: {
        success: 'La carta de venta fue publicada exitosamente.',
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.'
      },

      updateProductoPaginaIdroopPublicarPrimaria: {
        activationSuccess: 'La carta de venta fue publicada como primaria exitosamente.',
        deactivationSuccess: 'La carta de venta fue desactivada como primaria exitosamente.',
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.'
      }
    },

    externalSite: 'sitio externo',

    quote: {
      firstTextProductSalesLetters: 'Aún no tienes Cartas de Ventas asociadas a este producto. Agrega tu carta de venta haciendo',
      secondTextProductSalesLetters: 'click aquí.'
    },

    table: {
      thDelete: 'Eliminar',
      thEdit: 'Editar',
      thName: 'Nombre',
      thPusblished: 'Publicada',
      thPrimary: 'Primaria',
      thWatch: 'Ver'
    },

    tooltip: {
      delete: 'Eliminar Carta',
      edit: 'Editar Carta',
      watch: 'Ver Carta'
    }
  }
}

export default mEditionProductSalesLetters
